module.exports = __webpack_public_path__ + "static/media/stork.2595521a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stork.svg
// module id = 669
// module chunks = 0